class JatkaDpdFoodChecker extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.form = this.querySelector('form');
    this.input = this.querySelector('input');
    this.result = this.querySelector('[data-dpd-food-result]');
    this.listDate = this.querySelector('[data-dpd-food-list-date]');

    if (!this.form || !this.input || !this.result) return;

    if (this.listDate && window.JatkaDpdFoodCoverage?.listDateLabel) {
      this.listDate.textContent = window.JatkaDpdFoodCoverage.listDateLabel;
    }

    this.dataset.initialized = 'true';
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  handleSubmit(event) {
    event.preventDefault();

    const rawValue = this.input.value.trim();
    if (!/^\d{2}-?\d{3}$/.test(rawValue)) {
      this.input.setAttribute('aria-invalid', 'true');
      this.setResult('error', 'Wpisz kod w formacie 00-000.');
      return;
    }

    const digits = rawValue.replace('-', '');
    const formattedCode = `${digits.slice(0, 2)}-${digits.slice(2)}`;
    const numericCode = Number(digits);
    const coverage = window.JatkaDpdFoodCoverage;

    this.input.value = formattedCode;
    this.input.removeAttribute('aria-invalid');

    if (!coverage || !Array.isArray(coverage.ranges)) {
      this.setResult('error', 'Nie udało się sprawdzić kodu. Spróbuj ponownie lub skontaktuj się z nami.');
      return;
    }

    if (this.isCovered(numericCode, coverage.ranges)) {
      this.setResult('success', `Tak - DPD Food obsługuje kod ${formattedCode}. Dostawa kosztuje 39 zł.`);
      return;
    }

    this.setResult(
      'unavailable',
      'Ten kod nie znajduje się na aktualnej liście DPD Food. Sprawdź go ponownie w koszyku albo wybierz odbiór osobisty.'
    );
  }

  isCovered(code, ranges) {
    let left = 0;
    let right = ranges.length - 1;

    while (left <= right) {
      const middle = Math.floor((left + right) / 2);
      const [rangeStart, rangeEnd] = ranges[middle];

      if (code < rangeStart) {
        right = middle - 1;
      } else if (code > rangeEnd) {
        left = middle + 1;
      } else {
        return true;
      }
    }

    return false;
  }

  setResult(state, message) {
    this.result.dataset.state = state;
    this.result.textContent = message;
  }
}

if (!customElements.get('jatka-dpd-food-checker')) {
  customElements.define('jatka-dpd-food-checker', JatkaDpdFoodChecker);
}
